export function mapCurrentValuesToForm(currentValues) {
  return {
    name: currentValues.name
  }
}
